import React, { Fragment, useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import 'moment-timezone';
import moment from 'moment';
import Axios from 'axios';
import {
    Row,
    FormGroup,
    Label,
    Col,
    UncontrolledDropdown,
    DropdownItem,
    DropdownToggle,
    DropdownMenu,
    Spinner,
    Modal, ModalHeader,
    ModalBody, ModalFooter, Button
} from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import IntlMessages from '../../../../../../helpers/IntlMessages';
import country from '../../../../../../data/country';
import {
    week,
    month,
    last7Days,
    last30Days,
    last60Days,
    last90Days,
    LastDays,
    year,
} from '../../../../../app/dashboards/components/cards/lablesConfig';
import {
    gAPI_AdminNumberStats,
    gAPI_PropertiesDateStats,
    gAPI_ChatbotCountryCount,
    gAPI_PropertiesSearch,
    gAPI_Site_Settings
} from '../../../../../../constants/APIs';
import { GetCurrencyConversion } from '../../../../../../data/CurrencyConversion';
import NumberStats from './NumberStats';
import PropertiesDateChart from './PropertiesDateChart';
import ChatbotContryCounts from './ChatbotContryCounts';
import PropertiesList from './PropertiesList';
import ChatbotCountByType from './ChatbotCountByType';
import ChatbotCountByGroup from './ChatbotCountByGroup';
import CurrencyManager from './CurrencyManager';
const TypeList = [
    { label: "Activity Provider", value: "ActivityProvider" },
    { label: "CampGround", value: "CampGround" },
    { label: "Holiday Home", value: "HolidayHome" },
    { label: "Hostel", value: "Hostel" },
    { label: "Hotel", value: "Hotel" },
    { label: "Lodge", value: "Lodge" },
    { label: "Motel", value: "Motel" },
    { label: "Other Business Operator", value: "Bach" },
    { label: "Pub", value: "Pub" },
    { label: "Resort", value: "Resort" },
    { label: "Education", value: "Education" },
    { label: "Retail", value: "Retail" },
    { label: "Sports", value: "Sports" },
    { label: "Accommodation", value: "Accommodation" },
    { label: "Arts & Entertainment", value: "Arts_And_Entertainment" },
    { label: "Food & Drinks", value: "Food_And_Drinks" },
    { label: "Health & Wellness", value: "Health_And_Wellness" },
    { label: "Tours & Attraction", value: "Tours_And_Attraction" },
    { label: "Others", value: "Others" },
    { label: "Tourism Organisation", value: "TourismOrganisation" },
    { label: "Activities", value: "Activities" },
    { label: "Baby & Kids", value: "Baby_and_Kids" },
    { label: "Business Solutions", value: "Business_Solutions" },
    { label: "Events", value: "Events" },
    { label: "Gifts For Her", value: "Gifts_for_her" },
    { label: "Gifts For Him", value: "Gifts_for_him" },
    { label: "Home & Garden", value: "Home_and_Garden" },
    { label: "Health & Wellbeing", value: "Health_and_Wellbeing" },
    { label: "Seasonal", value: "Seasonal" },
    { label: "Travel", value: "Travel" },
    { label: "Business Operator", value: "BusinessOperator" }
]
export default function ChatbotsStats({
    timeZone,
    locale,
    propertyId,
    groupBillingCurrency,
}) {
    moment.tz.setDefault(timeZone);
    const [isShow, setIsShow] = useState(false);
    const [isError, setError] = useState(false);
    const [message, setMessage] = useState('');
    const [buttonText, setButtonText] = useState(
        <IntlMessages id="dashboards.last-7-days" />
    );
    const [labels, setLabels] = useState(last90Days);
    const [fromDate, setfromDate] = useState('');
    const [toDate, settoDate] = useState('');
    const [filterDate, setFilterDate] = useState(false);
    const [startDate, setStartDate] = useState(moment().subtract(15, 'days'));
    const [endDate, setEndDate] = useState(moment());
    const [isNumbers, setIsNumbers] = useState(true);
    const [numberStatistics, setNumberStatistics] = useState(null);
    const [isPropertyDate, setIsPropertyDate] = useState(true);
    const [propertiesDateStats, setPropertiesDateStats] = useState([]);
    const [isCountryCount, setIsCountryCount] = useState(true);
    const [chatbotCountryCounts, setChatbotCountryCounts] = useState([]);
    const [isTypeCount, setIsTypeCount] = useState(true);
    const [chatbotCountsByType, setChatbotCountsByType] = useState([]);
    const [isGroupCount, setIsGroupCount] = useState(true);
    const [chatbotCountsByGroup, setChatbotCountsByGroup] = useState([]);
    const [isPropertiesSearch, setIsPropertiesSearch] = useState(true);
    const [propertiesSearch, setPropertiesSearch] = useState([]);
    const [isCurrencyManager, setIsCurrencyManager] = useState(false);
    const [currencyRate, setCurrencyRate] = useState("");
    const [serviceProviderList, setServiceProviderList] = useState([]);
    const [serviceProvider, setServiceProvider] = useState(0);

    const countryDataTableColumns = [
        {
            Header: <IntlMessages id='dashboards.country' />,
            accessor: 'country',
            Cell: (props) => <p className="ml-2">{country.filter(con => con.code === props.value)[0]?.name}</p>,
        },
        {
            Header: 'Active Chatbots',
            accessor: 'activeChatbot',
            Cell: (props) => <p className="ml-5">{props.value}</p>,
        },
        {
            Header: 'Live Chatbots',
            accessor: 'liveChatbot',
            Cell: (props) => <p className="ml-5">{props.value}</p>,
        },
        {
            Header: 'MRR',
            accessor: 'conversionBillingAmount',
            Cell: (props) => <p className="">{numberFormat(Math.round(props.value), "NZD")} {" "}
                {props.value === props.original.monthlyBillingAmount ? "" :
                    <Fragment>
                        ( {numberFormat(Math.round(props.original.monthlyBillingAmount), props.original.currency ?? groupBillingCurrency)})
                    </Fragment>}
            </p>
        }
    ];
    const groupDataTableColumns = [
        {
            Header: 'Group',
            accessor: 'groupName',
            Cell: (props) => <p className="ml-2">{props.value}</p>,
        },
        {
            Header: 'Active Chatbots',
            accessor: 'activeChatbot',
            Cell: (props) => <p className="ml-5">{props.value}</p>,
        },
        {
            Header: 'Live Chatbots',
            accessor: 'liveChatbot',
            Cell: (props) => <p className="ml-5">{props.value}</p>,
        },
        {
            Header: 'MRR',
            accessor: 'conversionBillingAmount',
            Cell: (props) => {
                console.log('propp', props, props.original.currency)
                return (
                    <p className="">{numberFormat(Math.round(props.value), "NZD")} {" "}
                        {props.value === props.original.monthlyBillingAmount ? "" :
                            <Fragment>
                                ( {numberFormat(Math.round(props.original.monthlyBillingAmount), props.original.currency ?? groupBillingCurrency)})
                            </Fragment>}
                    </p>
                )
            }
        }
    ];
    const typeDataTableColumns = [
        {
            Header: 'Type',
            accessor: 'type',
            Cell: (props) => <p className="ml-2">{TypeList.filter(l => l.value === props.value).map(k => { return k.label })}</p>,
        },
        {
            Header: 'Active Chatbots',
            accessor: 'activeChatbot',
            Cell: (props) => <p className="ml-5">{props.value}</p>,
        },
        {
            Header: 'Live Chatbots',
            accessor: 'liveChatbot',
            Cell: (props) => <p className="ml-5">{props.value}</p>,
        }
    ];
    const dataTableColumnsProperties = [
        {
            Header: 'Group Name',
            accessor: 'groupName',
            Cell: (props) => <p className="">{props.value}</p>,
        },
        {
            Header: 'Property ',
            accessor: 'name',
            Cell: (props) => (
                <p className="">{props.value}</p>
            ),
        },
        {
            Header: <IntlMessages id='dashboards.country' />,
            accessor: 'country',
            Cell: (props) => (
                <p className="ml-3">{country.filter(con => con.code === props.value)[0].name}</p>
            ),
        },
        {
            Header: 'Live Date',
            accessor: 'activationDate',
            Cell: (props) => <p className="">{moment(props.value).format('lll')}</p>,
        },
        {
            Header: 'MRR',
            accessor: 'billingAmountConversion',
            Cell: (props) => (
                <p className="">
                    {numberFormat(Math.round(props.value), "NZD")}{" "}
                    {props.value === props.original.monthlyBillingAmount ? "" : (
                        <Fragment>
                            ({numberFormat(Math.round(props.original.monthlyBillingAmount), props.original.currency ?? groupBillingCurrency)})
                        </Fragment>
                    )}
                </p>
            )

        }
    ];


    const numberFormat = (value, currency) => {
        const format = new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: currency,
            currencyDisplay: 'narrowSymbol'
        });

        const formatted = format.format(value).replace(/(\.|,)00$/g, '');
        const symbolMatch = formatted.match(/[^\d\s.,-]+/);
        const symbol = symbolMatch ? symbolMatch[0] : '';

        // Remove all non-numeric characters except dots/commas
        const numberPart = formatted.replace(/[^0-9.,-]+/g, '');

        return `${currency} ${symbol}${numberPart}`;
    };


    useEffect(() => {
        selectLast7Days(true);
        GetRate();
        loadServiceProviderList();
    }, []);
    const GetRate = async () => {
        var rate = await GetCurrencyConversion(getGroupID());
        setCurrencyRate(rate);
    }

    const loadServiceProviderList = () => {
        AxiosAPI({
            method: 'get',
            url: `${gAPI_Site_Settings}`,
        }).then((res) => {
            if (res.data.length > 0) {
                setServiceProviderList(res.data);
            }
        });
    };

    const today = () => {
        return moment(moment().format('YYYY-MM-DD') + ' 23:59:59')
            .utc()
            .format('YYYY-MM-DD HH:mm:ss');
    };

    const daysAgo7 = () => {
        return moment(moment().subtract(6, 'days').format('YYYY-MM-DD HH:mm:ss'))
            .utc()
            .format('YYYY-MM-DD 00:00:00');
    };

    const daysAgo30 = () => {
        return moment(moment().subtract(29, 'days').format('YYYY-MM-DD HH:mm:ss'))
            .utc()
            .format('YYYY-MM-DD 00:00:00');
    };

    const daysAgo60 = () => {
        return moment(moment().subtract(59, 'days').format('YYYY-MM-DD HH:mm:ss'))
            .utc()
            .format('YYYY-MM-DD 00:00:00');
    };

    const daysAgo90 = () => {
        return moment(moment().subtract(89, 'days').format('YYYY-MM-DD HH:mm:ss'))
            .utc()
            .format('YYYY-MM-DD 00:00:00');
    };

    const startOfWeek = () => {
        const today = moment();
        return moment(moment(today).isoWeekday(1).format('YYYY-MM-DD HH:mm:ss'))
            .utc()
            .format('YYYY-MM-DD 00:00:00');
    };

    const endOfWeek = () => {
        const today = moment();
        return moment(
            moment(today).isoWeekday(7).format('YYYY-MM-DD') + ' 23:59:59'
        )
            .utc()
            .format('YYYY-MM-DD HH:mm:ss');
    };

    const startOfMonth = () => {
        return moment(moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'))
            .utc()
            .format('YYYY-MM-DD 00:00:00');
    };

    const startOfPreviousMonth = () => {
        return moment(
            moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD') +
            ' 00:00:00'
        )
            .utc()
            .format('YYYY-MM-DD HH:mm:ss');
    };

    const startOfThisYear = () => {
        return moment(new Date().getFullYear() + '-01-01' + ' 00:00:00').format(
            'YYYY-MM-DD HH:mm:ss'
        );
    };

    const startOfLastYear = () => {
        return moment(new Date().getFullYear() - 1 + '-01-01' + ' 00:00:00').format(
            'YYYY-MM-DD HH:mm:ss'
        );
    };
    const endOfLastYear = () => {
        return moment(new Date().getFullYear() - 1 + '-12-31' + ' 00:00:00').format(
            'YYYY-MM-DD HH:mm:ss'
        );
    };

    const endOfPreviousMonth = () => {
        return moment(
            moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD') +
            ' 23:59:59'
        )
            .utc()
            .format('YYYY-MM-DD HH:mm:ss');
    };

    const endOfMonth = () => {
        return moment(moment().endOf('month').format('YYYY-MM-DD') + ' 23:59:59')
            .utc()
            .format('YYYY-MM-DD HH:mm:ss');
    };

    const handleStartDate = (date) => {
        setStartDate(moment(date))
    };

    const handleEndDate = (date) => {
        setEndDate(moment(date))
    };
    const selectLast7Days = (val) => {
        setFilterDate(false);
        setButtonText(<IntlMessages id="dashboards.last-7-days" />);
        setLabels(val === true ? last90Days : last7Days);
        setfromDate(daysAgo7());
        settoDate(today());
        setIsNumbers(true);
        setIsPropertyDate(true);
        setIsCountryCount(true);
        setIsTypeCount(true);
        setIsGroupCount(true);
        setIsPropertiesSearch(true);
        Axios.all([
            AxiosAPI({
                method: 'get',
                url: `${gAPI_AdminNumberStats}`,
                params: {
                    dateFrom: daysAgo7(),
                    dateTo: today(),
                    provider: serviceProvider
                },
            }).then((res) => {
                setNumberStatistics(res.data);
                setIsNumbers(false);
            }),
            AxiosAPI({
                method: 'get',
                url: `${gAPI_PropertiesDateStats}`,
                params: {
                    dateFrom: val === true ? daysAgo90() : daysAgo7(),
                    dateTo: today(),
                    type: 0,
                    provider: serviceProvider
                },
            }).then((res) => {
                setPropertiesDateStats(res.data);
                setIsPropertyDate(false);
            }),
            AxiosAPI({
                method: 'get',
                url: `${gAPI_ChatbotCountryCount}`,
                params: {
                    dateFrom: daysAgo7(),
                    dateTo: today(),
                    provider: serviceProvider
                },
            }).then((res) => {
                setChatbotCountryCounts(res.data.countryCounts);
                setChatbotCountsByGroup(res.data.groupCounts);
                setChatbotCountsByType(res.data.typeCounts);
                setIsCountryCount(false);
                setIsTypeCount(false);
                setIsGroupCount(false);
            }),
            AxiosAPI({
                method: 'get',
                url: `${gAPI_PropertiesSearch}`,
                params: {
                    dateFrom: daysAgo7(),
                    dateTo: today(),
                    groupid: "-1",
                    status: "-1",
                    provider: "-1"
                },
            }).then((res) => {
                setPropertiesSearch(res.data.filter(elem => elem.status === "Live"));
                setIsPropertiesSearch(false);
            }),
        ]);
    };

    const selectLast30Days = () => {
        setFilterDate(false);
        setButtonText(<IntlMessages id="dashboards.last-30-days" />);
        setLabels(last30Days);
        setfromDate(daysAgo30());
        settoDate(today());
        setIsNumbers(true);
        setIsPropertyDate(true);
        setIsCountryCount(true);
        setIsTypeCount(true);
        setIsGroupCount(true);
        setIsPropertiesSearch(true);
        Axios.all([
            AxiosAPI({
                method: 'get',
                url: `${gAPI_AdminNumberStats}`,
                params: {
                    dateFrom: daysAgo30(),
                    dateTo: today(),
                    provider: serviceProvider
                },
            }).then((res) => {
                setNumberStatistics(res.data);
                setIsNumbers(false);
            }),
            AxiosAPI({
                method: 'get',
                url: `${gAPI_PropertiesDateStats}`,
                params: {
                    dateFrom: daysAgo30(),
                    dateTo: today(),
                    type: 0,
                    provider: serviceProvider
                },
            }).then((res) => {
                setPropertiesDateStats(res.data);
                setIsPropertyDate(false);
            }),
            AxiosAPI({
                method: 'get',
                url: `${gAPI_ChatbotCountryCount}`,
                params: {
                    dateFrom: daysAgo30(),
                    dateTo: today(),
                    provider: serviceProvider
                },
            }).then((res) => {
                setChatbotCountryCounts(res.data.countryCounts);
                setChatbotCountsByGroup(res.data.groupCounts)
                setChatbotCountsByType(res.data.typeCounts);
                setIsCountryCount(false);
                setIsTypeCount(false);
                setIsGroupCount(false);
            }),
            AxiosAPI({
                method: 'get',
                url: `${gAPI_PropertiesSearch}`,
                params: {
                    dateFrom: daysAgo30(),
                    dateTo: today(),
                    groupid: "-1",
                    status: "-1",
                    provider: "-1"
                },
            }).then((res) => {
                setPropertiesSearch(res.data.filter(elem => elem.status === "Live"));
                setIsPropertiesSearch(false);
            }),
        ]);
    };
    const selectLast60Days = () => {
        setButtonText(<IntlMessages id="dashboards.last-60-days" />);
        setLabels(last60Days);
        setFilterDate(false);
        setfromDate(daysAgo60());
        settoDate(today());
        setIsNumbers(true);
        setIsPropertyDate(true);
        setIsCountryCount(true);
        setIsTypeCount(true);
        setIsGroupCount(true);
        setIsPropertiesSearch(true);
        Axios.all([
            AxiosAPI({
                method: 'get',
                url: `${gAPI_AdminNumberStats}`,
                params: {
                    dateFrom: daysAgo60(),
                    dateTo: today(),
                    provider: serviceProvider
                },
            }).then((res) => {
                setNumberStatistics(res.data);
                setIsNumbers(false);
            }),
            AxiosAPI({
                method: 'get',
                url: `${gAPI_PropertiesDateStats}`,
                params: {
                    dateFrom: daysAgo60(),
                    dateTo: today(),
                    type: 0,
                    provider: serviceProvider
                },
            }).then((res) => {
                setPropertiesDateStats(res.data);
                setIsPropertyDate(false);
            }),
            AxiosAPI({
                method: 'get',
                url: `${gAPI_ChatbotCountryCount}`,
                params: {
                    dateFrom: daysAgo60(),
                    dateTo: today(),
                    provider: serviceProvider
                },
            }).then((res) => {
                setChatbotCountryCounts(res.data.countryCounts);
                setChatbotCountsByGroup(res.data.groupCounts);
                setChatbotCountsByType(res.data.typeCounts);
                setIsCountryCount(false);
                setIsTypeCount(false);
                setIsGroupCount(false);
            }),
            AxiosAPI({
                method: 'get',
                url: `${gAPI_PropertiesSearch}`,
                params: {
                    dateFrom: daysAgo60(),
                    dateTo: today(),
                    groupid: "-1",
                    status: "-1",
                    provider: "-1"
                },
            }).then((res) => {
                setPropertiesSearch(res.data.filter(elem => elem.status === "Live"));
                setIsPropertiesSearch(false);
            }),
        ]);
    };
    const selectLast90Days = () => {
        setFilterDate(false);
        setButtonText(<IntlMessages id="dashboards.last-90-days" />);
        setLabels(last90Days);
        setfromDate(daysAgo90());
        settoDate(today());
        setIsNumbers(true);
        setIsPropertyDate(true);
        setIsCountryCount(true);
        setIsTypeCount(true);
        setIsGroupCount(true);
        setIsPropertiesSearch(true);
        Axios.all([
            AxiosAPI({
                method: 'get',
                url: `${gAPI_AdminNumberStats}`,
                params: {
                    dateFrom: daysAgo90(),
                    dateTo: today(),
                    provider: serviceProvider
                },
            }).then((res) => {
                setNumberStatistics(res.data);
                setIsNumbers(false);
            }),
            AxiosAPI({
                method: 'get',
                url: `${gAPI_PropertiesDateStats}`,
                params: {
                    dateFrom: daysAgo90(),
                    dateTo: today(),
                    type: 0,
                    provider: serviceProvider
                },
            }).then((res) => {
                setPropertiesDateStats(res.data);
                setIsPropertyDate(false);
            }),
            AxiosAPI({
                method: 'get',
                url: `${gAPI_ChatbotCountryCount}`,
                params: {
                    dateFrom: daysAgo90(),
                    dateTo: today(),
                    provider: serviceProvider
                },
            }).then((res) => {
                setChatbotCountryCounts(res.data.countryCounts);
                setChatbotCountsByGroup(res.data.groupCounts);
                setChatbotCountsByType(res.data.typeCounts);
                setIsCountryCount(false);
                setIsTypeCount(false);
                setIsGroupCount(false);
            }),
            AxiosAPI({
                method: 'get',
                url: `${gAPI_PropertiesSearch}`,
                params: {
                    dateFrom: daysAgo90(),
                    dateTo: today(),
                    groupid: "-1",
                    status: "-1",
                    provider: "-1"
                },
            }).then((res) => {
                setPropertiesSearch(res.data.filter(elem => elem.status === "Live"));
                setIsPropertiesSearch(false);
            }),
        ]);
    };

    const handleFilterDateWise = (startDate, endDate) => {
        setfromDate(daysAgo90());
        settoDate(today());
        setIsNumbers(true);
        setIsPropertyDate(true);
        setIsCountryCount(true);
        setIsTypeCount(true);
        setIsGroupCount(true);
        setIsPropertiesSearch(true);
        Axios.all([
            AxiosAPI({
                method: 'get',
                url: `${gAPI_AdminNumberStats}`,
                params: {
                    dateFrom: startDate,
                    dateTo: endDate,
                    provider: serviceProvider
                },
            }).then((res) => {
                setNumberStatistics(res.data);
                setIsNumbers(false);
            }),
            AxiosAPI({
                method: 'get',
                url: `${gAPI_PropertiesDateStats}`,
                params: {
                    dateFrom: startDate,
                    dateTo: endDate,
                    type: 0,
                    provider: serviceProvider
                },
            }).then((res) => {
                setPropertiesDateStats(res.data);
                setIsPropertyDate(false);
            }),
            AxiosAPI({
                method: 'get',
                url: `${gAPI_ChatbotCountryCount}`,
                params: {
                    dateFrom: startDate,
                    dateTo: endDate,
                    provider: serviceProvider
                },
            }).then((res) => {
                setChatbotCountryCounts(res.data.countryCounts);
                setChatbotCountsByGroup(res.data.groupCounts);
                setChatbotCountsByType(res.data.typeCounts);
                setIsCountryCount(false);
                setIsTypeCount(false);
                setIsGroupCount(false);
            }),
            AxiosAPI({
                method: 'get',
                url: `${gAPI_PropertiesSearch}`,
                params: {
                    dateFrom: startDate,
                    dateTo: endDate,
                    groupid: "-1",
                    status: "-1",
                    provider: "-1"
                },
            }).then((res) => {
                setPropertiesSearch(res.data.filter(elem => elem.status === "Live"));
                setIsPropertiesSearch(false);
            }),
        ]);
    };

    const selectThisWeek = () => {
        setFilterDate(false);
        setButtonText(<IntlMessages id="dashboards.this-week" />);
        setLabels(week);
        setfromDate(startOfWeek());
        settoDate(endOfWeek());
        setIsNumbers(true);
        setIsPropertyDate(true);
        setIsCountryCount(true);
        setIsTypeCount(true);
        setIsGroupCount(true);
        setIsPropertiesSearch(true);
        Axios.all([
            AxiosAPI({
                method: 'get',
                url: `${gAPI_AdminNumberStats}`,
                params: {
                    dateFrom: startOfWeek(),
                    dateTo: endOfWeek(),
                    provider: serviceProvider
                },
            }).then((res) => {
                setNumberStatistics(res.data);
                setIsNumbers(false);
            }),
            AxiosAPI({
                method: 'get',
                url: `${gAPI_PropertiesDateStats}`,
                params: {
                    dateFrom: startOfWeek(),
                    dateTo: endOfWeek(),
                    type: 0,
                    provider: serviceProvider
                },
            }).then((res) => {
                setPropertiesDateStats(res.data);
                setIsPropertyDate(false);
            }),
            AxiosAPI({
                method: 'get',
                url: `${gAPI_ChatbotCountryCount}`,
                params: {
                    dateFrom: startOfWeek(),
                    dateTo: endOfWeek(),
                    provider: serviceProvider
                },
            }).then((res) => {
                setChatbotCountryCounts(res.data.countryCounts);
                setChatbotCountsByGroup(res.data.groupCounts);
                setChatbotCountsByType(res.data.typeCounts);
                setIsCountryCount(false);
                setIsTypeCount(false);
                setIsGroupCount(false);
            }),
            AxiosAPI({
                method: 'get',
                url: `${gAPI_PropertiesSearch}`,
                params: {
                    dateFrom: startOfWeek(),
                    dateTo: endOfWeek(),
                    groupid: "-1",
                    status: "-1",
                    provider: "-1"
                },
            }).then((res) => {
                setPropertiesSearch(res.data.filter(elem => elem.status === "Live"));
                setIsPropertiesSearch(false);
            }),
        ]);
    };

    const selectThisMonth = () => {
        setButtonText(<IntlMessages id="dashboards.this-month" />);
        setLabels(month);
        setFilterDate(false);
        setfromDate(startOfMonth());
        settoDate(endOfMonth());
        setIsNumbers(true);
        setIsPropertyDate(true);
        setIsCountryCount(true);
        setIsTypeCount(true);
        setIsGroupCount(true);
        setIsPropertiesSearch(true);
        Axios.all([
            AxiosAPI({
                method: 'get',
                url: `${gAPI_AdminNumberStats}`,
                params: {
                    dateFrom: startOfMonth(),
                    dateTo: endOfMonth(),
                    provider: serviceProvider
                },
            }).then((res) => {
                setNumberStatistics(res.data);
                setIsNumbers(false);
            }),
            AxiosAPI({
                method: 'get',
                url: `${gAPI_PropertiesDateStats}`,
                params: {
                    dateFrom: startOfMonth(),
                    dateTo: endOfMonth(),
                    type: 0,
                    provider: serviceProvider
                },
            }).then((res) => {
                setPropertiesDateStats(res.data);
                setIsPropertyDate(false);
            }),
            AxiosAPI({
                method: 'get',
                url: `${gAPI_ChatbotCountryCount}`,
                params: {
                    dateFrom: startOfMonth(),
                    dateTo: endOfMonth(),
                    provider: serviceProvider
                },
            }).then((res) => {
                setChatbotCountryCounts(res.data.countryCounts);
                setChatbotCountsByGroup(res.data.groupCounts);
                setChatbotCountsByType(res.data.typeCounts);
                setIsCountryCount(false);
                setIsTypeCount(false);
                setIsGroupCount(false);
            }),
            AxiosAPI({
                method: 'get',
                url: `${gAPI_PropertiesSearch}`,
                params: {
                    dateFrom: startOfMonth(),
                    dateTo: endOfMonth(),
                    groupid: "-1",
                    status: "-1",
                    provider: "-1"
                },
            }).then((res) => {
                setPropertiesSearch(res.data.filter(elem => elem.status === "Live"));
                setIsPropertiesSearch(false);
            }),
        ]);
    };

    const selectPreviousMonth = () => {
        setFilterDate(false);
        setButtonText(<IntlMessages id="dashboards.previous-month" />);
        setLabels(month);
        setfromDate(startOfPreviousMonth());
        settoDate(endOfPreviousMonth());
        setIsNumbers(true);
        setIsPropertyDate(true);
        setIsCountryCount(true);
        setIsTypeCount(true);
        setIsGroupCount(true);
        setIsPropertiesSearch(true);
        Axios.all([
            AxiosAPI({
                method: 'get',
                url: `${gAPI_AdminNumberStats}`,
                params: {
                    dateFrom: startOfPreviousMonth(),
                    dateTo: endOfPreviousMonth(),
                    provider: serviceProvider
                },
            }).then((res) => {
                setNumberStatistics(res.data);
                setIsNumbers(false);
            }),
            AxiosAPI({
                method: 'get',
                url: `${gAPI_PropertiesDateStats}`,
                params: {
                    dateFrom: startOfPreviousMonth(),
                    dateTo: endOfPreviousMonth(),
                    type: 0,
                    provider: serviceProvider
                },
            }).then((res) => {
                setPropertiesDateStats(res.data);
                setIsPropertyDate(false);
            }),
            AxiosAPI({
                method: 'get',
                url: `${gAPI_ChatbotCountryCount}`,
                params: {
                    dateFrom: startOfPreviousMonth(),
                    dateTo: endOfPreviousMonth(),
                    provider: serviceProvider
                },
            }).then((res) => {
                setChatbotCountryCounts(res.data.countryCounts);
                setChatbotCountsByGroup(res.data.groupCounts);
                setChatbotCountsByType(res.data.typeCounts);
                setIsCountryCount(false);
                setIsTypeCount(false);
                setIsGroupCount(false);
            }),
            AxiosAPI({
                method: 'get',
                url: `${gAPI_PropertiesSearch}`,
                params: {
                    dateFrom: startOfPreviousMonth(),
                    dateTo: endOfPreviousMonth(),
                    groupid: "-1",
                    status: "-1",
                    provider: "-1"
                },
            }).then((res) => {
                setPropertiesSearch(res.data.filter(elem => elem.status === "Live"));
                setIsPropertiesSearch(false);
            }),
        ]);
    };

    const selectThisYear = () => {
        setButtonText(<IntlMessages id="dashboards.yeartodate" />);
        setLabels(year);
        setFilterDate(false);
        setfromDate(startOfThisYear());
        settoDate(today());
        setIsNumbers(true);
        setIsPropertyDate(true);
        setIsCountryCount(true);
        setIsTypeCount(true);
        setIsGroupCount(true);
        setIsPropertiesSearch(true);
        Axios.all([
            AxiosAPI({
                method: 'get',
                url: `${gAPI_AdminNumberStats}`,
                params: {
                    dateFrom: startOfThisYear(),
                    dateTo: today(),
                    provider: serviceProvider
                },
            }).then((res) => {
                setNumberStatistics(res.data);
                setIsNumbers(false);
            }),
            AxiosAPI({
                method: 'get',
                url: `${gAPI_PropertiesDateStats}`,
                params: {
                    dateFrom: startOfThisYear(),
                    dateTo: today(),
                    type: 1,
                    provider: serviceProvider
                },
            }).then((res) => {
                setPropertiesDateStats(res.data);
                setIsPropertyDate(false);
            }),
            AxiosAPI({
                method: 'get',
                url: `${gAPI_ChatbotCountryCount}`,
                params: {
                    dateFrom: startOfThisYear(),
                    dateTo: today(),
                    provider: serviceProvider
                },
            }).then((res) => {
                setChatbotCountryCounts(res.data.countryCounts);
                setChatbotCountsByGroup(res.data.groupCounts);
                setChatbotCountsByType(res.data.typeCounts);
                setIsCountryCount(false);
                setIsTypeCount(false);
                setIsGroupCount(false);
            }),
            AxiosAPI({
                method: 'get',
                url: `${gAPI_PropertiesSearch}`,
                params: {
                    dateFrom: startOfThisYear(),
                    dateTo: today(),
                    groupid: "-1",
                    status: "-1",
                    provider: "-1"
                },
            }).then((res) => {
                setPropertiesSearch(res.data.filter(elem => elem.status === "Live"));
                setIsPropertiesSearch(false);
            }),
        ]);
    };

    const selectLastYear = () => {
        setFilterDate(false);
        setButtonText(<IntlMessages id="dashboards.lastyear" />);
        setLabels(year);
        setfromDate(startOfLastYear());
        settoDate(endOfLastYear());
        setIsNumbers(true);
        setIsPropertyDate(true);
        setIsCountryCount(true);
        setIsTypeCount(true);
        setIsGroupCount(true);
        setIsPropertiesSearch(true);
        Axios.all([
            AxiosAPI({
                method: 'get',
                url: `${gAPI_AdminNumberStats}`,
                params: {
                    dateFrom: startOfLastYear(),
                    dateTo: endOfLastYear(),
                    provider: serviceProvider
                },
            }).then((res) => {
                setNumberStatistics(res.data);
                setIsNumbers(false);
            }),
            AxiosAPI({
                method: 'get',
                url: `${gAPI_PropertiesDateStats}`,
                params: {
                    dateFrom: startOfLastYear(),
                    dateTo: endOfLastYear(),
                    type: 1,
                    provider: serviceProvider
                },
            }).then((res) => {
                setPropertiesDateStats(res.data);
                setIsPropertyDate(false);
            }),
            AxiosAPI({
                method: 'get',
                url: `${gAPI_ChatbotCountryCount}`,
                params: {
                    dateFrom: startOfLastYear(),
                    dateTo: endOfLastYear(),
                    provider: serviceProvider
                },
            }).then((res) => {
                setChatbotCountryCounts(res.data.countryCounts);
                setChatbotCountsByGroup(res.data.groupCounts);
                setChatbotCountsByType(res.data.typeCounts);
                setIsCountryCount(false);
                setIsTypeCount(false);
                setIsGroupCount(false);
            }),
            AxiosAPI({
                method: 'get',
                url: `${gAPI_PropertiesSearch}`,
                params: {
                    dateFrom: startOfLastYear(),
                    dateTo: endOfLastYear(),
                    groupid: "-1",
                    status: "-1",
                    provider: "-1"
                },
            }).then((res) => {
                setPropertiesSearch(res.data.filter(elem => elem.status === "Live"));
                setIsPropertiesSearch(false);
            }),
        ]);
    };


    const handleFilterMonthWise = (startDate, endDate) => {
        setLabels(year);
        setfromDate(startOfLastYear());
        settoDate(endOfLastYear());
        setIsNumbers(true);
        setIsPropertyDate(true);
        setIsCountryCount(true);
        setIsTypeCount(true);
        setIsGroupCount(true);
        setIsPropertiesSearch(true);
        Axios.all([
            AxiosAPI({
                method: 'get',
                url: `${gAPI_AdminNumberStats}`,
                params: {
                    dateFrom: startDate,
                    dateTo: endDate,
                    provider: serviceProvider
                },
            }).then((res) => {
                setNumberStatistics(res.data);
                setIsNumbers(false);
            }),
            AxiosAPI({
                method: 'get',
                url: `${gAPI_PropertiesDateStats}`,
                params: {
                    dateFrom: startDate,
                    dateTo: endDate,
                    type: 0,
                    provider: serviceProvider
                },
            }).then((res) => {
                setPropertiesDateStats(res.data);
                setIsPropertyDate(false);
            }),
            AxiosAPI({
                method: 'get',
                url: `${gAPI_ChatbotCountryCount}`,
                params: {
                    dateFrom: startDate,
                    dateTo: endDate,
                    provider: serviceProvider
                },
            }).then((res) => {
                setChatbotCountryCounts(res.data.countryCounts);
                setChatbotCountsByGroup(res.data.groupCounts);
                setChatbotCountsByType(res.data.typeCounts);
                setIsCountryCount(false);
                setIsTypeCount(false);
                setIsGroupCount(false);
            }),
            AxiosAPI({
                method: 'get',
                url: `${gAPI_PropertiesSearch}`,
                params: {
                    dateFrom: startDate,
                    dateTo: endDate,
                    groupid: "-1",
                    status: "-1",
                    provider: "-1"
                },
            }).then((res) => {
                setPropertiesSearch(res.data.filter(elem => elem.status === "Live"));
                setIsPropertiesSearch(false);
            }),
        ]);

    }

    const handleFilter = () => {
        let diff = endDate.diff(startDate, 'days');
        setButtonText('Date Range');
        if (diff > 365) {
            setMessage("The start and end date must be within a year of each other.");
            setError(true);
            return;
        }
        if (diff > 90) {
            setIsShow(false);
            setLabels(year);
            handleFilterMonthWise(moment(startDate).format('YYYY-MM-DD 00:00:00'), moment(endDate).format('YYYY-MM-DD') + ' 23:59:59');
            setFilterDate(true);

        } else {
            if (diff >= 60)
                setLabels(LastDays(startDate, endDate));
            else if (diff >= 30)
                setLabels(LastDays(startDate, endDate));
            else if (diff >= 7)
                setLabels(LastDays(startDate, endDate));
            else
                setLabels(LastDays(startDate, endDate));
            setIsShow(false);
            handleFilterDateWise(moment(startDate).format('YYYY-MM-DD 00:00:00'), moment(endDate).format('YYYY-MM-DD') + ' 23:59:59');
            setFilterDate(true);
        }
    };


    const clickServiceProvider = (sp) => {
        setServiceProvider(sp);
        if (buttonText.props.id === "dashboards.last-7-days") {
            selectLast7Days();
        }
        else if (buttonText.props.id === "dashboards.last-30-days") {
            selectLast30Days();
        }
        else if (buttonText.props.id === "dashboards.last-60-days") {
            selectLast60Days();
        }
        else if (buttonText.props.id === "dashboards.last-90-days") {
            selectLast90Days();
        }
        else if (buttonText.props.id === "dashboards.this-week") {
            selectThisWeek();
        }
        else if (buttonText.props.id === "dashboards.this-month") {
            selectThisMonth();
        }
        else if (buttonText.props.id === "dashboards.previous-month") {
            selectPreviousMonth();
        }
        else if (buttonText.props.id === "dashboards.yeartodate") {
            selectThisYear();
        } else if (buttonText.props.id === "dashboards.lastyear") {
            selectLastYear();
        }
    }
    return (
        <Fragment>
            <Row>
                <Col xxs="12" className="mb-2">
                    <Fragment>
                        {filterDate === true && <div className='float-left mt-2'>
                            <span className='mr-2'><b><IntlMessages id="dashboards.form" /> : </b>{moment(startDate).format('DD')}/{moment(startDate).format('MM')}/{moment(startDate).format('YYYY')}</span>
                            <span className='ml-2'><b><IntlMessages id="dashboards.to" /> : </b>{moment(endDate).format('DD')}/{moment(endDate).format('MM')}/{moment(endDate).format('YYYY')}</span>
                        </div>}
                        <div className="d-flex float-right float-none-xs mb-3">
                            <UncontrolledDropdown>
                                <DropdownToggle
                                    caret
                                    color="primary"
                                    className="btn-xs"
                                    outline
                                >
                                    {serviceProviderList && serviceProviderList.filter(x => x.id === serviceProvider).length > 0 ?
                                        serviceProviderList.filter(x => x.id === serviceProvider).map(m => m.fromName) : "All"}
                                </DropdownToggle>
                                <DropdownMenu right>
                                    <DropdownItem onClick={() => clickServiceProvider(0)}>
                                        All
                                    </DropdownItem>
                                    {serviceProviderList && serviceProviderList.map((elem) => (
                                        <DropdownItem onClick={() => clickServiceProvider(elem.id)}>
                                            {elem.fromName}
                                        </DropdownItem>
                                    ))}
                                </DropdownMenu>
                            </UncontrolledDropdown>
                            <Button color="primary"
                                className="top-right-button mr-1"
                                outline
                                size="xs"
                                onClick={() => setIsCurrencyManager(true)}>Currency Manager</Button>
                            <UncontrolledDropdown>
                                <DropdownToggle
                                    caret
                                    color="primary"
                                    className="btn-xs"
                                    outline
                                >
                                    {buttonText}
                                </DropdownToggle>
                                <DropdownMenu right>
                                    <DropdownItem onClick={selectLast7Days}>
                                        <IntlMessages id="dashboards.last-7-days" />
                                    </DropdownItem>
                                    <DropdownItem onClick={selectLast30Days}>
                                        <IntlMessages id="dashboards.last-30-days" />
                                    </DropdownItem>
                                    <DropdownItem onClick={selectLast60Days}>
                                        <IntlMessages id="dashboards.last-60-days" />
                                    </DropdownItem>
                                    <DropdownItem onClick={selectLast90Days}>
                                        <IntlMessages id="dashboards.last-90-days" />
                                    </DropdownItem>
                                    <DropdownItem onClick={selectThisWeek}>
                                        <IntlMessages id="dashboards.this-week" />
                                    </DropdownItem>
                                    <DropdownItem onClick={selectThisMonth}>
                                        <IntlMessages id="dashboards.this-month" />
                                    </DropdownItem>
                                    <DropdownItem onClick={selectPreviousMonth}>
                                        <IntlMessages id="dashboards.previous-month" />
                                    </DropdownItem>
                                    <DropdownItem onClick={selectThisYear}>
                                        <IntlMessages id="dashboards.yeartodate" />
                                    </DropdownItem>
                                    <DropdownItem onClick={selectLastYear}>
                                        <IntlMessages id="dashboards.lastyear" />
                                    </DropdownItem>
                                    <DropdownItem onClick={() => setIsShow(!isShow)}>
                                        <IntlMessages id="form-components.date-range" />
                                    </DropdownItem>
                                </DropdownMenu>
                            </UncontrolledDropdown>
                        </div>
                    </Fragment>
                </Col>
            </Row>
            <Row>
                <Col sm="12" md="12" className="mb-4">
                    {isNumbers ? (
                        <div className="text-center">
                            <Spinner color="primary" className="mb-1" />
                        </div>
                    ) : (
                        <NumberStats
                            numberdata={numberStatistics}
                            locale={locale}
                            currencyRate={currencyRate}
                        />
                    )}
                </Col>
                <Col sm="12" md="6" className="mb-4">
                    {isPropertyDate ? (
                        <div className="text-center">
                            <Spinner color="primary" className="mb-1" />
                        </div>
                    ) : (
                        <PropertiesDateChart
                            labels={labels}
                            propertyData={propertiesDateStats}
                        />
                    )}
                </Col>
                <Col sm="12" md="6" className="mb-4">
                    {isCountryCount ? (
                        <div className="text-center">
                            <Spinner color="primary" className="mb-1" />
                        </div>
                    ) : (
                        <ChatbotContryCounts
                            labels={countryDataTableColumns}
                            data={chatbotCountryCounts}
                        />
                    )}
                </Col>
                <Col sm="12" md="6" className="mb-4">
                    {isTypeCount ? (
                        <div className="text-center">
                            <Spinner color="primary" className="mb-1" />
                        </div>
                    ) : (
                        <ChatbotCountByType
                            labels={typeDataTableColumns}
                            data={chatbotCountsByType}
                        />
                    )}
                </Col>
                <Col sm="12" md="6" className="mb-4">
                    {isGroupCount ? (
                        <div className="text-center">
                            <Spinner color="primary" className="mb-1" />
                        </div>
                    ) : (
                        <ChatbotCountByGroup
                            labels={groupDataTableColumns}
                            data={chatbotCountsByGroup}
                        />
                    )}
                </Col>
                <Col sm="12" md="12" className="mb-4">
                    {isPropertiesSearch ? (
                        <div className="text-center">
                            <Spinner color="primary" className="mb-1" />
                        </div>
                    ) : (
                        <PropertiesList
                            data={propertiesSearch}
                            timeZone={timeZone}
                            labels={dataTableColumnsProperties}
                            fromDate={fromDate}
                            toDate={toDate}>
                        </PropertiesList>
                    )}
                </Col>
            </Row>
            <Modal isOpen={isShow}
                toggle={() => setIsShow(!isShow)} style={{ borderRadius: '10px' }}>
                <ModalHeader toggle={() => setIsShow(!isShow)}>
                    <IntlMessages id="form-components.date-range" />
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <Colxx md="4" className="mb-2">
                            <FormGroup>
                                <Label><IntlMessages id='dashboards.start-date' /></Label>
                                <DatePicker
                                    style={{ borderRadius: "10px" }}
                                    selected={startDate ? new Date(startDate) : null} // ensure Date object
                                    onChange={handleStartDate}
                                    placeholderText="Start Date"
                                    dateFormat="dd/MM/yyyy"   // ✅ correct format
                                />
                            </FormGroup>
                        </Colxx>

                        <Colxx md="4" className="mb-2">
                            <FormGroup>
                                <Label> <IntlMessages id='dashboards.end-date' /></Label>
                                <DatePicker
                                    style={{ borderRadius: '10px' }}
                                    selected={endDate ? new Date(endDate) : null}
                                    onChange={handleEndDate}
                                    placeholderText="End Date"
                                    dateFormat="dd/MM/yyyy"
                                />
                            </FormGroup>
                        </Colxx>
                    </Row>

                </ModalBody>
                <ModalFooter>
                    <Button color='primary' onClick={() => handleFilter()}>Submit</Button>
                    <Button className="ml-2" onClick={() => setIsShow(!isShow)}>Close</Button>
                </ModalFooter>
            </Modal>

            {isCurrencyManager &&
                <CurrencyManager
                    visible={isCurrencyManager}
                    toggle={() => setIsCurrencyManager(!isCurrencyManager)}
                ></CurrencyManager>
            }
        </Fragment>
    )
}